import {createContext} from 'react'

export const WindowContext = createContext([])
export const ArticleContext = createContext({})
export const AppContext = createContext([])
export const ProductContext = createContext({})
export const ChatContext = createContext({})
export const WorkspaceContext = createContext([])
